import request from '@/utils/ajax';



export function queryDimensionList(data) {
  return request({
    url: `/wx/sys/dataPermissionDimension/list`,
    method: 'get',
    params: data
  });
}

// 添加权限表
export function addTable(data) {
  return request({
    url: `/wx/sys/dataPermissionTable/save`,
    method: 'POST',
    data: data
  });
}

export function updateTable(data) {
  return request({
    url: `/wx/sys/dataPermissionTable/update`,
    method: 'post',
    data: data
  });
}

export function deteleTable(data) {
  return request({
    url: `/wx/sys/dataPermissionTable/delete`,
    method: 'post',
    data: data
  });
}
